/*
  Not fully migrated, this is here to support the footer migration.
  Please check and migrate correctly
*/

import type { RouteRecordRaw } from 'vue-router'

export const BUYING_GUIDE = {
  ROOT_HUB: 'root_hub_buying_guide',
  HUB: 'hub_buying_guide',
  SELF: 'buying_guide',
}

const routes: RouteRecordRaw[] = [
  {
    path: '/:locale/c',
    name: BUYING_GUIDE.ROOT_HUB,
    component: () => import('./LayoutRootHub.vue'),
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
